import { Link } from "react-router-dom";
import { products } from "../../Data/ProductData";
import paddyOperation from "../../Images/client/field/electric-cono-weeder-paddy-field.jpg";
import { Container, SectionHeading, Arrow } from "./UI";

function homeProductImage(product) {
  if (product.id === 2) return paddyOperation;
  const farmImage = product.gallery.find((image) => image.source === "SNB/client asset audit");
  return farmImage?.src || product.pic[0];
}

export function MachineCard({ product }) {
  const image = homeProductImage(product);

  return (
    <article className="sn-group sn-flex sn-h-full sn-flex-col sn-overflow-hidden sn-rounded-card sn-border sn-border-line sn-bg-white sn-transition hover:-sn-translate-y-1">
      <Link
        to={`/products/${product.slug}`}
        aria-label={`Explore ${product.title}`}
        className="sn-relative sn-block sn-bg-sage"
      >
        <img
          src={image}
          alt={`${product.title} in field use`}
          width="560"
          height="420"
          loading="lazy"
          className="sn-h-auto sn-aspect-[4/3] sn-w-full sn-object-cover sn-photo"
          style={product.id === 2 ? { objectPosition: "50% 58%" } : undefined}
        />
      </Link>
      <div className="sn-flex sn-flex-1 sn-flex-col sn-p-6">
        <h3 className="sn-font-display sn-text-xl sn-leading-snug sn-tracking-tight sn-text-forest">
          {product.title}
        </h3>
        <p className="sn-mt-3 sn-text-sm sn-leading-relaxed sn-text-muted">
          {product.desc}
        </p>

        <Link
          to={`/products/${product.slug}`}
          className="sn-mt-auto sn-flex sn-min-h-[44px] sn-items-center sn-justify-between sn-text-sm sn-font-semibold sn-text-forest hover:sn-text-leaf"
        >
          Explore machine
          <Arrow />
        </Link>
      </div>
    </article>
  );
}
export default function FeaturedProducts() {
  return (
    <section
      aria-labelledby="sn-machines-title"
      className="sn-bg-white sn-py-16 md:sn-py-24"
    >
      <Container>
        <div className="sn-mb-10 sn-flex sn-flex-col sn-gap-6 md:sn-flex-row md:sn-items-end md:sn-justify-between">
          <SectionHeading id="sn-machines-title" eyebrow="Our Machines">
            First of its kind
            <br />
            All-Electric Weeders
          </SectionHeading>
          <Link
            to="/products"
            className="sn-inline-flex sn-min-h-[44px] sn-items-center sn-gap-5 sn-text-sm sn-font-semibold sn-text-forest"
          >
            View all machines
            <Arrow />
          </Link>
        </div>
        <div className="sn-grid sn-gap-6 md:sn-grid-cols-3">
          {products
            .filter((p) => [1, 2, 3].includes(p.id))
            .map((product) => (
              <MachineCard key={product.id} product={product} />
            ))}
        </div>
      </Container>
    </section>
  );
}
